import { ThemeOptions, createTheme } from '@mui/material';

const primary = '#1A6797';

const themeOptions: ThemeOptions = {
  palette: {
    primary: {
      main: primary,
    },
    secondary: {
      main: '#7ec0e9',
    },
    inverted: {
      contrastText: primary,
      main: '#fff',
    },
  },
};

export const wpTheme = createTheme(themeOptions);


declare module '@mui/material/styles' {
  interface Theme {
    status?: {
      danger: React.CSSProperties['color'];
    };
  }

  interface Palette {
    inverted: Palette['primary'];
  }
  interface PaletteOptions {
    inverted: PaletteOptions['primary'];
  }

  interface PaletteColor {
    darker?: string;
  }
  interface SimplePaletteColorOptions {
    darker?: string;
  }
  interface ThemeOptions {
    status?: {
      danger: React.CSSProperties['color'];
    };
  }
}

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    inverted: true;
  }
}